// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__17hs2","header":"ReportDetails_header__3ANli","title":"ReportDetails_title__oLPAS","left":"ReportDetails_left__3-kmK"};